export default "__VITE_ASSET__697f947e__"